
import { useEffect, useState } from 'react';
import Frontend from './Frontend';
import Languages from './Language';
import './skills.css';
import './etc.css';
import Backend from './Backend';
import Databases from './Databases';
import Collaboration from './Collaboration';

import spring from "../imgs/spring-svgrepo-com.svg";
import nodejs from "../imgs/nodejs-svgrepo-com.svg";
import django from "../imgs/django-svgrepo-com.svg";
import intellij from "../imgs/intellij-idea-svgrepo-com.svg";
import eclipse from "../imgs/eclipse-icon-svgrepo-com.svg";
import vscode from "../imgs/vs-code-svgrepo-com.svg";
import git from "../imgs/github-142-svgrepo-com.svg";
import slack from "../imgs/slack-svgrepo-com.svg";
import discord from "../imgs/discord-svgrepo-com.svg";
import angular from "../imgs/angular-svgrepo-com.svg";
import vue from "../imgs/vue-svgrepo-com.svg";
import css from "../imgs/css-3-svgrepo-com.svg";
import html from "../imgs/html-5-svgrepo-com.svg";
import jsp from "../imgs/jsp-file-format-symbol-svgrepo-com.svg";
import react from "../imgs/react-svgrepo-com.svg";
import ejs from "../imgs/ejs-svgrepo-com.svg";
import java from "../imgs/java-4-logo-svgrepo-com.svg";
import python from "../imgs/python-svgrepo-com.svg";
import cpp from "../imgs/cpp-svgrepo-com.svg";
import js from "../imgs/js-svgrepo-com.svg";
import mysql from "../imgs/mysql-logo-svgrepo-com.svg";
import postgresql from "../imgs/postgresql-svgrepo-com.svg";
import mariadb from "../imgs/mariadb-svgrepo-com.svg";
import mongodb from "../imgs/mongodb-svgrepo-com.svg";
import firebase from "../imgs/firebase-svgrepo-com.svg";
import redis from "../imgs/redis-svgrepo-com.svg";
import { forwardRef } from 'react';

const Skills = forwardRef((props, ref) => {
  const [correct, setCorrect] = useState([false]);
      const [isWrong, setIsWrong] = useState([false]); // 틀렸을 때 메시지
  
      const checkAnswer = (answer, num) => {
          if (answer === "java" && num === 0) {
              // 배열의 특정 인덱스를 바로 변경
              setCorrect(prev => prev.map((val, index) => index === num ? true : val));
          } else {
              setIsWrong(prev => prev.map((val, index) => index === num ? true : val)); // 틀린 답 처리
              setTimeout(() => {
                  setIsWrong(prev => prev.map((val, index) => index === num ? false : val)); // 1초 후 흔들림 상태 초기화
              }, 1500); // 애니메이션 시간이 끝난 후 초기화
          }
      };

    useEffect(() => {
        const observerOptions = {
          rootMargin: "0px",
          threshold: 0.5, // 화면의 50%가 보일 때 트리거
        };
    
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add("show"); // 화면에 보일 때 show 클래스를 추가
            }
          });
        }, observerOptions);
    
        // 각 intro 요소를 관찰
        const elementsToObserve = document.querySelectorAll(".guide, .skills-contents, .skill-quiz, .skills-contents-elements");
        elementsToObserve.forEach(el => observer.observe(el));
      }, []);

    return (
        <div ref={ref} className="skills">

            <div className="skills-header">SKILLS</div>
            
                <div className="guide">퀴즈를 맞춰서 확인해 보세요</div>
            <div className='skills-contents'>

                <div className='skill-quiz'>
                  <div className={`skill-language-quiz ${isWrong[0] ? 'language-wrong-answer' : correct[0] ? 'skill-correct-answer' : ''}`} >
                    <div className="language-quiz-question">
                        Question. "  "는 썬 마이크로시스템즈에서 1995년에 개발한 <br />
                        객체 지향 프로그래밍 언어이다. 이때 "  "는?
                    </div>
                    <div className="skill-quiz-answer">
                        <div className="first" onClick={() => checkAnswer("java", 0)}>
                            <img src={java} alt="Java" />
                        </div>
                        <div className="second" onClick={() => checkAnswer("python", 0)}>
                            <img src={python} alt="Python" />
                        </div>
                        <div className="third" onClick={() => checkAnswer("cpp", 0)}>
                            <img src={cpp} alt="C++" />
                        </div>
                    </div>
                    {isWrong[0] && <div className="skill-language-wrong">다시 생각해보세요</div>}
                    {correct[0] && <div className="skill-language-correct-message">정답!</div>}
                
                  </div>
                </div>

                <div className='skills-contents-elements'>
                  {/* <Languages />
                  <Frontend />
                  <Backend />
                  <Databases />
                  <Collaboration /> */}
                  <div className="etc-skills">
                      <div className="skills-row">

                        <div className="skills-column">
                          <h3 className='etc-skill-header'>Language</h3>
                          <div className='etc-skill-contents'>
                            <div className="etc-skill">
                              <img src={java} alt="Java" />
                              <span>Java</span>
                            </div>
                            <div className="etc-skill">
                              <img src={python} alt="Python" />
                              <span>Python</span>
                            </div>
                            <div className="etc-skill">
                              <img src={js} alt="JavaScript" />
                              <span>JavaScript</span>
                            </div>
                          </div>
                        </div>

                        <div className="skills-column">
                        <h3 className='etc-skill-header'>Front-End</h3>
                        
                        <div className='etc-skill-contents'>
                            <div className="etc-skill">
                              <img src={react} alt="React" />
                              <span>React</span>
                            </div>
                            <div className="etc-skill">
                              <img src={jsp} alt="Jsp" />
                              <span>JSP</span>
                            </div>
                            <div className="etc-skill">
                              <img src={ejs} alt="Ejs" />
                              <span>EJS</span>
                            </div>
                            <div className="etc-skill">
                              <img src={html} alt="HTML" />
                              <span>HTML</span>
                            </div>
                            <div className="etc-skill">
                              <img src={css} alt="CSS" />
                              <span>CSS</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="skills-row">
                        <div className="skills-column">
                        <h3 className='etc-skill-header'>Back-End</h3>
                        
                        <div className='etc-skill-contents'>
                          <div className="etc-skill">
                            <img src={nodejs} alt="Node.js" />
                            <span>Node.js</span>
                          </div>
                          <div className="etc-skill">
                            <img src={spring} alt="Spring" />
                            <span>Spring</span>
                          </div>
                        </div>
                      </div>

                        <div className="skills-column">
                          <h3 className='etc-skill-header'>Database</h3>
                          
                          <div className='etc-skill-contents'>
                            <div className="etc-skill">
                              <img src={mysql} alt="MySQL" />
                              <span>MySQL</span>
                            </div>
                            <div className="etc-skill">
                              <img src={mariadb} alt="MariaDB" />
                              <span>MariaDB</span>
                            </div>
                            <div className="etc-skill">
                              <img src={mongodb} alt="MongoDB" />
                              <span>MongoDB</span>
                            </div>
                            <div className="etc-skill">
                              <img src={firebase} alt="Firebase" />
                              <span>Firebase</span>
                            </div>
                            <div className="etc-skill">
                              <img src={redis} alt="Redis" />
                              <span>Redis</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="skills-row">
                        <div className="skills-column">
                          <h3 className='etc-skill-header'>Tools & Collaborations</h3>


                          <div className='etc-skill-contents'>
                            <div className="etc-skill">
                              <img src={eclipse} alt="Eclipse" />
                              <span>Eclipse</span>
                            </div>
                            <div className="etc-skill">
                              <img src={vscode} alt="VScode" />
                              <span>VScode</span>
                            </div>
                            <div className="etc-skill">
                              <img src={git} alt="Git" />
                              <span>Git</span>
                            </div>

                            <div className="etc-skill">
                              <img src={slack} alt="Slack" />
                              <span>Slack</span>
                            </div>
                            <div className="etc-skill">
                              <img src={discord} alt="Discord" />
                              <span>Discord</span>
                            </div>
                          </div>

                        </div>
                      </div>
                  </div>
                </div>
            </div>
            
        </div>
    );
});

export default Skills;
